module.exports = __webpack_public_path__ + "a56e4a498d4e6572bdde72ea497469c9.svg";